// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"1c42539c","239":"9f5d0972","396":"df490eb5","455":"eaedad34","514":"c9ec9ee9","977":"78b3c76a"}[chunkId] + ".chunk.js";
};